import { render, staticRenderFns } from "./DownloadInvoice.vue?vue&type=template&id=4060de80&scoped=true"
import script from "./DownloadInvoice.vue?vue&type=script&lang=ts"
export * from "./DownloadInvoice.vue?vue&type=script&lang=ts"
import style0 from "./DownloadInvoice.vue?vue&type=style&index=0&id=4060de80&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060de80",
  null
  
)

export default component.exports